import { cn } from "@/libs/utils";

import { Option } from "@/types/Shared/select";

type Props = {
  className?: string;
  defaultValue: string;
  optionList: Option[];
  useAll?: boolean;
  onChange: (value: string, object: Option) => void;
};
export default function CommonSelect({
  className,
  defaultValue,
  optionList,
  useAll = true,
  onChange,
}: Props) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    const selectedOption = optionList.find((o) => o.value === e.target.value)!;
    onChange(value, selectedOption);
  };
  return (
    <select
      className={cn(
        "h-[30px] border-[1px] px-[4px] py-[4px] border-gray-D rounded-[4px] text-[10px]",
        className
      )}
      value={defaultValue}
      onChange={handleChange}
    >
      {useAll && <option value="ALL">전체</option>}
      {optionList.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
